<template>
    <main v-if="isLoaded" id="detail-ticket" class="form-v2" role="main">
        <portal to="ariane">
            <nav class="tbv2-breadcrumb" aria-label="Breadcrumb">
                <router-link to="/forms" class="tbv2-breadcrumb-link">{{ $t('forms.mine') }}</router-link>
                <span class="tbv2-breadcrumb-sep" aria-hidden="true">/</span>
                <span class="tbv2-breadcrumb-current">{{ form.name }}</span>
            </nav>
        </portal>

        <header class="form-hero">
            <div class="form-hero-main">
                <h1 class="form-hero-title">{{ form.name }}</h1>
                <p v-if="form.description" class="form-hero-desc" v-html="form.description"></p>
            </div>
            <div class="form-hero-actions">
                <router-link
                    :to="{ name: 'EditForm', params: { formId: form.id } }"
                    class="form-hero-edit"
                >
                    <i class="fal fa-edit"></i>
                    <span>{{ $t('common.edit') }}</span>
                </router-link>
            </div>
        </header>

        <FormMenu />
    </main>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FormMenu from '@/components/Model/Form/FormComponents/FormMenu'

export default {
    name: 'Form',
    components: { FormMenu },
    data() {
        return {
            isLoaded: false
        }
    },
    created() {
        var id = this.$route.params.id
        this.getForm(id).then(() => {
            this.isLoaded = true
        })
    },
    computed: {
        ...mapState('form', {
            form: (state) => state.form
        })
    },
    methods: {
        ...mapActions('form', ['getForm'])
    }
}
</script>

<style scoped>
.form-v2 {
    width: 100%;
    padding: 24px 32px 48px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-breadcrumb {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 0.875rem;
    font-weight: var(--v2-font-weight-medium);
}

.tbv2-breadcrumb-link {
    color: var(--v2-text-3);
    text-decoration: none;
    transition: color var(--v2-transition-fast);
}

.tbv2-breadcrumb-link:hover {
    color: var(--v2-primary);
}

.tbv2-breadcrumb-sep {
    color: var(--v2-text-4);
    font-weight: 400;
}

.tbv2-breadcrumb-current {
    color: var(--v2-text-1);
    font-weight: var(--v2-font-weight-semibold);
    letter-spacing: -0.005em;
}

.form-hero {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--v2-space-4);
    margin-bottom: var(--v2-space-5);
}

.form-hero-main {
    flex: 1;
    min-width: 0;
}

.form-hero-title {
    margin: 0 0 6px;
    font-size: 1.75rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.form-hero-desc {
    margin: 0;
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
    line-height: 1.5;
    max-width: 720px;
}

.form-hero-desc >>> p {
    margin: 0;
}

.form-hero-actions {
    flex-shrink: 0;
}

.form-hero-edit {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 12px;
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-sm);
    background: var(--v2-surface-0);
    color: var(--v2-text-2);
    font-size: 0.82rem;
    font-weight: var(--v2-font-weight-medium);
    line-height: 1.2;
    text-decoration: none !important;
    box-sizing: border-box;
    transition: background var(--v2-transition-fast), color var(--v2-transition-fast);
}

.form-hero-edit:hover {
    background: var(--v2-surface-2);
    color: var(--v2-text-1);
    text-decoration: none !important;
}

.form-hero-edit i {
    font-size: 0.8rem;
}

@media (max-width: 900px) {
    .form-v2 {
        padding: 16px 18px 32px;
    }

    .form-hero {
        flex-direction: column;
        gap: var(--v2-space-3);
    }

    .form-hero-title {
        font-size: 1.375rem;
    }
}
</style>
